import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import SeoHead from '../../components/feature/SeoHead';
import SustainabilityHero from './components/SustainabilityHero';
import RenewableEnergy from './components/RenewableEnergy';
import EnvironmentalActivities from './components/EnvironmentalActivities';
import CircularEconomy from './components/CircularEconomy';
import EnvironmentalManagement from './components/EnvironmentalManagement';
import SustainabilityCTA from './components/SustainabilityCTA';

const siteUrl = (import.meta.env.VITE_SITE_URL as string | undefined) ?? '';

const sustainabilityJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  name: 'サステナビリティ | 株式会社C.GREEN | 再生可能エネルギー・循環型経済',
  url: `${siteUrl}/sustainability`,
  description:
    '株式会社C.GREENのサステナビリティへの取り組みをご紹介。再生可能エネルギー活用・循環型経済・環境マネジメントなど、持続可能な事業活動を解説します。',
  inLanguage: 'ja',
  breadcrumb: {
    '@type': 'BreadcrumbList',
    itemListElement: [
      { '@type': 'ListItem', position: 1, name: 'ホーム', item: siteUrl },
      { '@type': 'ListItem', position: 2, name: 'サステナビリティ', item: `${siteUrl}/sustainability` },
    ],
  },
};

export default function SustainabilityPage() {
  return (
    <div className="min-h-screen bg-white">
      <SeoHead
        title="サステナビリティ | 株式会社C.GREEN | 再生可能エネルギー・循環型経済"
        description="株式会社C.GREENのサステナビリティへの取り組みをご紹介。再生可能エネルギー活用・循環型経済・環境マネジメントなど、持続可能な事業活動を解説します。"
        keywords="サステナビリティ,再生可能エネルギー,循環型経済,環境マネジメント,C.GREEN環境,持続可能な事業"
        canonicalPath="/sustainability"
        jsonLd={sustainabilityJsonLd}
      />
      <Navbar />
      <SustainabilityHero />
      <RenewableEnergy />
      <EnvironmentalActivities />
      <CircularEconomy />
      <EnvironmentalManagement />
      <SustainabilityCTA />
      <Footer />
    </div>
  );
}
